// Modules
import React from 'react'
import { Button, Intent, NonIdealState } from '@blueprintjs/core'

// Components
import Page from 'components/layout/page/Page'

// Hooks
import useLanguage from 'hooks/system/useLanguage'

// Component: Utility > Loading error
function LoadingError () {
	// Data
	const { translate } = useLanguage('components.utility.loadingError')

	// Render
	return (
		<Page name="loading-error">
			<Page.Section
				willGrow
				willCenter
				name="message">
				<NonIdealState
					icon="offline"
					title={translate.local('title')}
					description={translate.local('description')}
					action={
						<Button
							large
							icon="refresh"
							intent={Intent.PRIMARY}
							style={{ marginTop: '2rem' }}
							onClick={() => window.location.reload()}>
							{translate.global('actions.refreshPage')}
						</Button>
					} />
			</Page.Section>
		</Page>
	)
}

// Export
export default LoadingError
